/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadSOffenderRecord
 */
export interface LeadSOffenderRecord {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    is_dismissed?: boolean;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    middle_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    aliases?: string;
    /**
     * 
     */
    dob?: string;
    /**
     * 
     */
    gender?: string;
    /**
     * 
     */
    race?: string;
    /**
     * 
     */
    height?: string;
    /**
     * 
     */
    weight?: string;
    /**
     * 
     */
    hair?: string;
    /**
     * 
     */
    eyes?: string;
    /**
     * 
     */
    marks?: string;
    /**
     * 
     */
    is_predator?: boolean;
    /**
     * 
     */
    is_absconder?: boolean;
    /**
     * 
     */
    charges?: string;
    /**
     * 
     */
    address_line_1?: string;
    /**
     * 
     */
    address_line_2?: string;
    /**
     * 
     */
    state?: string;
    /**
     * 
     */
    location?: string;
    /**
     * 
     */
    zip?: string;
    /**
     * 
     */
    latitude?: number;
    /**
     * 
     */
    longitude?: number;
    /**
     * 
     */
    changes?: string;
    /**
     * 
     */
    external_created?: string;
    /**
     * 
     */
    external_last_updated?: string;
    /**
     * 
     */
    image_url?: string;
    /**
     * 
     */
    profile_url?: string;
    /**
     * The source of the match:
     * - NAME: Record found by searching first and last name
     * - EXACT_ALIAS: Record found by searching exact alias
     * - NICKNAME: Record found via nickname matching
     * 
     */
    match_source?: LeadSOffenderRecordMatchSourceEnum;
    /**
     * How well the date of birth matches:
     * - EXACT: Lead DOB matches offender DOB exactly
     * - NEAR_DOB: Offender DOB is within 30 days of lead DOB
     * - YEAR_ONLY: Only the year matches (including 1/1/YYYY placeholder dates)
     * - NEAR_AGE: Age is within 2 years of lead age (used when no valid DOB)
     * - UNKNOWN_OR_MISSING: DOB of offender is missing or unknown
     * 
     */
    dob_match_type?: LeadSOffenderRecordDobMatchTypeEnum;
    /**
     * 
     */
    age?: number;
    /**
     * Comma-joined list of known nicknames (Offenders.io only)
     */
    nicknames?: string;
    /**
     * Risk level from the offender registry (Offenders.io only)
     */
    risk_level?: string;
    /**
     * 
     */
    deleted_at?: string;
    /**
     * 
     */
    created_at?: string;
}


/**
 * @export
 */
export const LeadSOffenderRecordMatchSourceEnum = {
    Name: 'NAME',
    ExactAlias: 'EXACT_ALIAS',
    Nickname: 'NICKNAME',
} as const;
export type LeadSOffenderRecordMatchSourceEnum = typeof LeadSOffenderRecordMatchSourceEnum[keyof typeof LeadSOffenderRecordMatchSourceEnum];

/**
 * @export
 */
export const LeadSOffenderRecordDobMatchTypeEnum = {
    Exact: 'EXACT',
    NearDob: 'NEAR_DOB',
    YearOnly: 'YEAR_ONLY',
    NearAge: 'NEAR_AGE',
    UnknownOrMissing: 'UNKNOWN_OR_MISSING',
} as const;
export type LeadSOffenderRecordDobMatchTypeEnum = typeof LeadSOffenderRecordDobMatchTypeEnum[keyof typeof LeadSOffenderRecordDobMatchTypeEnum];


/**
 * Check if a given object implements the LeadSOffenderRecord interface.
 */
export function instanceOfLeadSOffenderRecord(value: object): value is LeadSOffenderRecord {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    return true;
}

export function LeadSOffenderRecordFromJSON(json: any): LeadSOffenderRecord {
    return LeadSOffenderRecordFromJSONTyped(json, false);
}

export function LeadSOffenderRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadSOffenderRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'],
        'is_dismissed': json['is_dismissed'] == null ? undefined : json['is_dismissed'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'aliases': json['aliases'] == null ? undefined : json['aliases'],
        'dob': json['dob'] == null ? undefined : json['dob'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'race': json['race'] == null ? undefined : json['race'],
        'height': json['height'] == null ? undefined : json['height'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'hair': json['hair'] == null ? undefined : json['hair'],
        'eyes': json['eyes'] == null ? undefined : json['eyes'],
        'marks': json['marks'] == null ? undefined : json['marks'],
        'is_predator': json['is_predator'] == null ? undefined : json['is_predator'],
        'is_absconder': json['is_absconder'] == null ? undefined : json['is_absconder'],
        'charges': json['charges'] == null ? undefined : json['charges'],
        'address_line_1': json['address_line_1'] == null ? undefined : json['address_line_1'],
        'address_line_2': json['address_line_2'] == null ? undefined : json['address_line_2'],
        'state': json['state'] == null ? undefined : json['state'],
        'location': json['location'] == null ? undefined : json['location'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'changes': json['changes'] == null ? undefined : json['changes'],
        'external_created': json['external_created'] == null ? undefined : json['external_created'],
        'external_last_updated': json['external_last_updated'] == null ? undefined : json['external_last_updated'],
        'image_url': json['image_url'] == null ? undefined : json['image_url'],
        'profile_url': json['profile_url'] == null ? undefined : json['profile_url'],
        'match_source': json['match_source'] == null ? undefined : json['match_source'],
        'dob_match_type': json['dob_match_type'] == null ? undefined : json['dob_match_type'],
        'age': json['age'] == null ? undefined : json['age'],
        'nicknames': json['nicknames'] == null ? undefined : json['nicknames'],
        'risk_level': json['risk_level'] == null ? undefined : json['risk_level'],
        'deleted_at': json['deleted_at'] == null ? undefined : json['deleted_at'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
    };
}

export function LeadSOffenderRecordToJSON(json: any): LeadSOffenderRecord {
    return LeadSOffenderRecordToJSONTyped(json, false);
}

export function LeadSOffenderRecordToJSONTyped(value?: LeadSOffenderRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'is_dismissed': value['is_dismissed'],
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'aliases': value['aliases'],
        'dob': value['dob'],
        'gender': value['gender'],
        'race': value['race'],
        'height': value['height'],
        'weight': value['weight'],
        'hair': value['hair'],
        'eyes': value['eyes'],
        'marks': value['marks'],
        'is_predator': value['is_predator'],
        'is_absconder': value['is_absconder'],
        'charges': value['charges'],
        'address_line_1': value['address_line_1'],
        'address_line_2': value['address_line_2'],
        'state': value['state'],
        'location': value['location'],
        'zip': value['zip'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'changes': value['changes'],
        'external_created': value['external_created'],
        'external_last_updated': value['external_last_updated'],
        'image_url': value['image_url'],
        'profile_url': value['profile_url'],
        'match_source': value['match_source'],
        'dob_match_type': value['dob_match_type'],
        'age': value['age'],
        'nicknames': value['nicknames'],
        'risk_level': value['risk_level'],
        'deleted_at': value['deleted_at'],
        'created_at': value['created_at'],
    };
}

